import { apiDelete } from "../ApiMethod";

export const deleteDroneNestById = async (id) => {
  const response = await apiDelete("_dronenest", id);
  return { ...response };
};
